import React from 'react';
import { Navigate } from 'react-router-dom';

/** Redirect non-admins to a safe default page (read-only lists work for all roles). */
export function RequireAdmin({ user, children }) {
  if (!user || user.role !== 'admin') {
    return <Navigate to="/drivers" replace />;
  }
  return children;
}

export function HomeRedirect({ user }) {
  const to = user?.role === 'admin' ? '/users' : '/drivers';
  return <Navigate to={to} replace />;
}

export default RequireAdmin;
